// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from "react";
import { useContext } from "react";

import Box from "@mui/material/Box"; // Import Box
import { Locales } from "@simplyk/common";

import { FrontendFormContext } from "../../contexts/FrontendFormContext";
import { useLocaleContext } from "../../contexts/LocaleContext";
import { useTranslate } from "../../hooks/useTranslate";
import { FormDialog } from "../forms-design-system/FormDialog";
import { FormDivider } from "../forms-design-system/FormDivider";
import { FormTypography } from "../forms-design-system/FormTypography";

import { DialogProps } from "@/dashboard-design-system/Dialog";

type FormLearnMoreOnZeffyDialogProps = Pick<DialogProps, "open" | "onClose">;

export const FormLearnMoreOnZeffyDialog: React.FunctionComponent<
  React.PropsWithChildren<FormLearnMoreOnZeffyDialogProps>
> = (props: FormLearnMoreOnZeffyDialogProps) => {
  const { t } = useTranslate();
  const { organization } = useContext(FrontendFormContext);
  const { locale } = useLocaleContext();

  return (
    <FormDialog title={t("donationForm", "zeffyLearnMore.title")} {...props}>
      <FormTypography variant="body2">
        {t("donationForm", "zeffyLearnMore.description", { organizationName: organization.name })}{" "}
        <FormTypography fontWeight="600" variant="body2" component="span">
          {t("donationForm", "zeffyLearnMore.uniqueFeature")}{" "}
        </FormTypography>
        <FormTypography fontWeight="600" variant="body2" sx={(theme) => ({ marginTop: theme.spacing(3) })}>
          {t("donationForm", "zeffyLearnMore.callToAction")}
        </FormTypography>
        <Box component="ul" sx={{ pl: 2, mt: 1 }}>
          {[
            t("donationForm", "zeffyLearnMore.list.text1"),
            t("donationForm", "zeffyLearnMore.list.text2"),
            t("donationForm", "zeffyLearnMore.list.text3"),
          ].map((contribution, index) => (
            <Box
              component="li"
              key={index}
              sx={(theme) => ({
                marginTop: theme.spacing(1),
              })}
            >
              {contribution}
            </Box>
          ))}
        </Box>
      </FormTypography>

      {locale === Locales.EN && (
        <>
          <FormDivider />
          <Box sx={{ mt: 3, textAlign: "center" }}>
            <Box
              component="iframe"
              src="https://fast.wistia.com/embed/medias/2d6hysapuf"
              sx={(theme) => ({
                width: "100%",
                maxWidth: "303px",
                aspectRatio: "303 / 170", // Maintain the aspect ratio
                borderRadius: 1,
                border: `1px solid ${theme.palette.primary.main}`,
              })}
              frameBorder="0"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              title="Learn about Zeffy"
            />
            <FormTypography variant="caption" sx={{ mt: 0.5 }} component="div">
              Watch this 2 min. video to learn more about Zeffy
            </FormTypography>
          </Box>
        </>
      )}
    </FormDialog>
  );
};
